export default __webpack_public_path__ + "c4b8281484912962a24a2dfc64e29a4f.png";